import { PolicyDetailScreen } from "@softmax/web-ux/policies";
import { buildHref } from "@softmax/web-addresses";
import { NavigationFailure } from "@softmax/web-features/navigation/markers";

export function PolicyNotFound() {
  return (
    <>
      <NavigationFailure />
      <PolicyDetailScreen
        back={{
          href: buildHref({ name: "policies" }),
          label: "Back to policies",
        }}
        state={{
          status: "empty",
          title: "Policy not found",
          message: "This policy has no visible versions.",
        }}
      />
    </>
  );
}
